import classNames from 'classnames';
import { format } from 'date-fns';
import { ref, remove, update } from 'firebase/database';
import { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { AttachModal } from './AttachModal';
import EditGroupModal from './EditGroupModal';
import { createNotebooksFunc, getTeacherScheduleBoard, getTeachers, getStudentsGroupView } from '../../Common/Database';
import { database } from '../../Common/Firebase';
import Loader from '../../Components/Loader';
import Tooltipe from '../../Components/Tooltipe';
import { throwErrorRollbar } from '../../index';
import { getUserType } from '../../redux/slices/userSlice';

import '../StudentView/style.scss';
import './style.scss';

const StudentsGroupView = ({ mail }) => {
  const { t, i18n } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const userTypeSelector = useSelector(getUserType);

  const [studentGroup, setStudentGroup] = useState();
  const [subjectList, setSubjectList] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [addSubject, setAddSubject] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [userType, setUserType] = useState(userTypeSelector);
  const [openTeacherAttachModal, setOpenTeacherAttachModal] = useState(false);
  const [listTeachers, setListTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [curentSubject, setCurentSubject] = useState();
  const [itemTeacher, setItemTeacher] = useState('');
  const [fioStudent, setFioStudent] = useState('');

  const admins = userType === 'NewAdmin' || userType === 'Admin' || userType === 'Superadmin';

  useEffect(() => {
    if (location && location.state && location.state.fio) {
      setFioStudent(location.state.fio);
    }
  }, [location]);

  const fetchStudentsGroupView = async () => {
    try {
      await getStudentsGroupView(params.id).then(response => {
        const resp = response.val();
        let stSubjects = Object.values(resp.subjects);
        setStudentGroup(resp);
        setSubjectList(stSubjects);

        setIsLoading(false);
      });
    } catch (error) {
      console.error('Error fetching schedule:', error);
    }
  };

  const feachTeacher = async () => {
    await getTeachers().then(response => {
      const arrTeachers = Object.values(response);
      setListTeachers(arrTeachers);
      setIsLoading(false);
    });
  };

  const openModalUpdateStudentsGroup = async () => {
    setOpenModal(true);
    await getStudentsGroupView(params.id).then(response => {
      const resp = response.val();
      setStudentGroup(resp);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    setUserType(userTypeSelector);
    fetchStudentsGroupView();

    if (admins) {
      feachTeacher();
    }
  }, [addSubject, userTypeSelector, userType, curentSubject, selectedTeacher]);

  useEffect(() => {
    const table = document.getElementById('student-subjects');
    if (table) {
      const tbody = table.querySelector('tbody');
      if (tbody) {
        const rows = tbody.getElementsByTagName('tr');
        for (let i = 0; i < rows.length; i++) {
          const cells = rows[i].getElementsByTagName('td');
          let allEmpty = true;
          for (let j = 0; j < cells.length; j++) {
            if (cells[j].innerText.trim() !== '') {
              allEmpty = false;
              break;
            }
          }
          rows[i].style.display = allEmpty ? 'none' : '';
        }
      }
    }
  });

  const columns = admins
    ? [
        {
          dataField: 'name',
          text: t('subjects'),
          attrs: { 'data-label': t('subject') },
          disableClickEventBubbling: true,
          formatter: cell => t(cell),
        },
        {
          dataField: 'attachedTeacher.FIO',
          text: t('Responsible teacher'),
          attrs: { 'data-label': t('Responsible teacher') },
          disableClickEventBubbling: true,
          formatter: cell => {
            return cell ? cell : '-';
          },
        },
        {
          dataField: 'activeSub',
          text: t('subject activation'),
          attrs: { 'data-label': t('activation') },
          disableClickEventBubbling: true,
          formatter: dataField => {
            const buttonStyles = {
              background: dataField ? '#f2e6ed' : '#9cdffc',
            };

            return (
              <button id={String(dataField)} style={buttonStyles} className="btn btn-primary more btn-active">
                {dataField ? t('delete') : t('add')}
              </button>
            );
          },
        },
        {
          dataField: 'id',
          text: <div className="sticky-wrap">{t('options')}</div>,
          attrs: { 'data-label': t('options') },
          formatter: (dataField, row) => {
            return (
              <div className="actions-wrap">
                {row.attachedTeacher ? (
                  <Tooltipe text="edit a teacher" icon="icon-checked-icon" btnClass="attach-teacher" />
                ) : (
                  <Tooltipe text="appoint a teacher" icon="icon-plus1" btnClass="attach-teacher" />
                )}
              </div>
            );
          },
        },
      ]
    : [
        {
          dataField: 'name',
          text: t('subjects'),
          attrs: { 'data-label': t('subject') },
          disableClickEventBubbling: true,
          formatter: (cell, row) => {
            if (row.attachedTeacher && row.attachedTeacher.id === mail) {
              return t(cell);
            }
          },
        },

        {
          dataField: 'id',
          text: <div className="sticky-wrap">{t('options')}</div>,
          attrs: { 'data-label': t('options') },
          formatter: (dataField, row) => {
            if (row.attachedTeacher && row.attachedTeacher.id === mail) {
              return (
                <div className="actions-wrap">
                  <Tooltipe text="schedule" icon="icon-schedule" btnClass="move-schedule" />
                </div>
              );
            }
          },
        },
      ];

  const rowEvents = {
    onClick: async (e, row) => {
      if (e.target.className === 'btn btn-primary more btn-active') {
        try {
          const now = new Date();
          const formattedTime = format(now, 'dd MM yyyy HH:mm');
          const subjectName = row.name;
          setAddSubject(prev => !prev);

          await update(ref(database, `StudentsGroup/${params.id}`), {
            active: !row.active,
          });

          await update(ref(database, `StudentsGroup/${params.id}/subjects/${subjectName}`), {
            activeSub: !row.activeSub,
            // getNotebook: true,
            schedule: !row.activeSub,
            attachedTeacher: {},
          });

          location.state.stEmails.map(async email => {
            const notificationData = {
              id: params.id,
              idItem: subjectName,
              name: subjectName,
              subject: subjectName,
              time: formattedTime,
              subType: 'add-subject',
              viewed: true,
            };

            if (!row.getNotebook) {
              createNotebooksFunc(email, row.name);
            }

            if (row.activeSub) {
              notificationData.type = 'subjects-remove';
            } else {
              notificationData.type = 'subjects';
            }

            await update(ref(database, `Students/${email}/subjects/${subjectName}`), {
              activeSub: !row.activeSub,
              getNotebook: true,
              schedule: !row.activeSub,
              attachedTeacher: {},
            });

            await update(ref(database, `Students/${email}/notification`), {
              [subjectName + params.id + uuidv4()]: notificationData,
            });

            await remove(ref(database, `Students/${email}/schedule/${subjectName}`));

            // try {
            //   const response = await getTeacherScheduleBoard(mail);
            //   const resp = response.val();
            //   console.log('resp: ', resp);

            //   let stSchedule = Object.values(resp);

            //   for (const items of stSchedule) {
            //     let itemsMap = Object.values(items);
            //     for (const filterItem of itemsMap) {
            //       if (filterItem.student === student.FIO) {
            //         await remove(
            //           ref(
            //             database,
            //             `Teachers/${mail}/schedule/${subjectName}/${filterItem.id}`,
            //           ),
            //         );
            //       }
            //     }
            //   }
            // } catch (error) {
            //   console.error('Error fetching schedule:', error);
            // }

            fetchStudentsGroupView();
          });
        } catch (error) {
          console.log(error);
          throwErrorRollbar(error);
        }
      }

      if (e.target.className === 'btn btn-icon attach-teacher') {
        setOpenTeacherAttachModal(true);
        setCurentSubject(row);
      }

      if (e.target.className === 'btn btn-icon move-schedule') {
        sessionStorage.setItem('StudentView', JSON.stringify(row));
        navigate(`/schedule/${params.id}/subjects/${row.name}`);
      }

      if (e.target.className === 'btn btn-icon move-view') {
        sessionStorage.setItem('StudentView', JSON.stringify(row));
        navigate(`/classroomGroup/${params.id}/${row.name}`, { state: row });
      }

      if (e.target.className === 'btn btn-icon btn-action-menu') {
        setOpenDrops(prev => ({
          ...prev,
          [row.name]: !prev[row.name],
        }));
      }
    },

    // formatExtraData: openDrops,
  };

  const onAttachStudent = async () => {
    try {
      const now = new Date();
      const formattedTime = format(now, 'dd MM yyyy HH:mm');
      const subjectName = curentSubject.name;

      await update(ref(database, `StudentsGroup/${params.id}/subjects/${subjectName}`), {
        activeSub: true,
        // getNotebook: true,
        schedule: true,
        attachedTeacher: {
          id: itemTeacher.email.replace(/\./g, ''),
          FIO: itemTeacher.FIO,
          firstName: itemTeacher.firstName,
          lastName: itemTeacher.lastName,
          patronymic: itemTeacher.patronymic,
        },
      });

      studentGroup.students.map(async student => {
        if (!curentSubject.getNotebook) {
          createNotebooksFunc(student.email, curentSubject.name);
        }

        await update(ref(database, `Students/${student.email}/subjects/${subjectName}`), {
          activeSub: true,
          getNotebook: true,
          attachedTeacher: {
            id: itemTeacher.email.replace(/\./g, ''),
            FIO: itemTeacher.FIO,
            firstName: itemTeacher.firstName,
            lastName: itemTeacher.lastName,
            patronymic: itemTeacher.patronymic,
          },
          schedule: true,
        });

        await update(ref(database, `Students/${student.email}/notification`), {
          ['attachedTeacher' + itemTeacher.email.replace(/\./g, '') + subjectName]: {
            id: itemTeacher.email.replace(/\./g, '') + subjectName,
            idItem: subjectName,
            name: itemTeacher.FIO,
            subject: subjectName,
            time: formattedTime,
            type: 'subjects add-teacher',
            subType: 'add-subject',
            viewed: true,
          },
        });

        await update(ref(database, `Teachers/${itemTeacher.email.replace(/\./g, '')}/notification`), {
          ['attachedTeacheradd-student' + params.id + subjectName]: {
            id: params.id + subjectName,
            idItem: subjectName,
            name: studentGroup.groupName,
            subject: subjectName,
            time: formattedTime,
            type: 'subjects add-group',
            subType: 'add-student',
            viewed: true,
            studentMail: params.id,
          },
        });
      });
    } catch (error) {
      console.error('Error fetching teacher info', error);
    }

    setOpenTeacherAttachModal(false);
    fetchStudentsGroupView();
  };

  const onTeacherChange = selectedTeacher => {
    const filterData = listTeachers.filter(item => {
      if (selectedTeacher == item.FIO) {
        return item;
      }
    });
    setSelectedTeacher(selectedTeacher);
    setItemTeacher(filterData[0]);
  };

  return (
    <div className="student-view-page container">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="list-wrap student-wrap">
            <h2>
              {t('group information')}:
              {admins && (
                <Tooltipe method={openModalUpdateStudentsGroup} text="update" icon="icon-edit-1" btnClass="move-view" />
              )}
            </h2>

            {studentGroup && (
              <ul className="studetn-data-list">
                <li>
                  <span className="key">{t('groupName')}: </span>
                  <span className="value">{studentGroup && studentGroup.groupName}</span>
                </li>
                <li>
                  <span className="key">{t('studentsList')}: </span>
                  {studentGroup &&
                    studentGroup.students.map(student => {
                      return <span className="value">{student.FIO}</span>;
                    })}
                </li>
                <li>
                  <span className="key">{t('subjects list')}: </span>
                  {Object.values(studentGroup.subjects).map(item => {
                    if (item.activeSub && item.attachedTeacher) {
                      return (
                        <div className="items-wrap">
                          <span className="value">{t(item.name)}</span>
                          <span className="dash">-</span>
                          <span key={item.name} className="value">
                            {t(item.attachedTeacher.FIO)}
                          </span>
                        </div>
                      );
                    }
                  })}
                </li>
              </ul>
            )}
          </div>
          <div className="list-wrap subjects-wrap students-page">
            <h2>{t('subjects')}:</h2>

            {subjectList && subjectList ? (
              <ToolkitProvider key={i18n.language} keyField="name" data={subjectList} columns={columns}>
                {props => (
                  <div>
                    <div className="materials-table">
                      <BootstrapTable {...props.baseProps} rowEvents={rowEvents} id="student-subjects" />
                    </div>
                  </div>
                )}
              </ToolkitProvider>
            ) : (
              <></>
            )}

            {openModal && (
              <EditGroupModal
                open={openModal}
                setOpen={setOpenModal}
                studentGroup={studentGroup}
                fetchStudentsGroupView={fetchStudentsGroupView}
                onAttachStudent={onAttachStudent}
              />
            )}

            <div
              className={classNames('popup-send-homework student-attach', {
                active: openTeacherAttachModal,
              })}
            >
              {openTeacherAttachModal && (
                <AttachModal
                  setOpenTeacherAttachModal={setOpenTeacherAttachModal}
                  selectedTeacher={selectedTeacher}
                  onTeacherChange={onTeacherChange}
                  listTeachers={listTeachers}
                  onAttachStudent={onAttachStudent}
                />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default StudentsGroupView;
